import { useRef } from "react";
import { isFunction } from "lodash";

type ValidationFunction = () => Promise<boolean>;

export const useValidateFormSections = () => {
  const triggerValidationRef = useRef<ValidationFunction | null>(null);

  const validateAndSetCurrentSection = async (
    sectionKey: string,
    setCurrentSection: (sectionKey: string) => void,
  ) => {
    if (isFunction(triggerValidationRef.current)) {
      const isValid = await triggerValidationRef.current();
      if (!isValid) {
        return;
      }
    }

    setCurrentSection(sectionKey);
  };

  return {
    validateAndSetCurrentSection,
    triggerValidationRef,
  };
};
